;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface CoinIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CoinIcon({ size = 24, ...props }: CoinIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Coin">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1 4C11 3.33333 9.6 3 8 3C6.4 3 5 3.33333 3.9 4C2.8 4.55556 2 5.44444 2 6.66667V9.55556C2 10.6667 2.9 11.5556 4.2 12.2222C4.8 12.5556 5.5 12.7778 6.2 12.8889C6.8 12.8889 7.4 13 8 13C11.3 13 14 11.4444 14 9.44445V6.66667C14 5.44444 13.2 4.55556 12.1 4ZM4.3 5C5.3 4.44444 6.5 4.11111 8 4.11111C9.5 4.11111 10.8 4.44444 11.7 5C12.7 5.55556 13 6.11111 13 6.66667C13 6.88889 12.9 7.11111 12.8 7.33333C12.6 7.66667 12.2 8 11.7 8.33333C11.2 8.55556 10.7 8.66667 10.2 8.88889C9.5 9 8.8 9.11111 8 9.11111C7.2 9.11111 6.5 9 5.8 8.88889C5.3 8.66667 4.8 8.55556 4.3 8.33333C3.8 8 3.4 7.55556 3.2 7.22222C3.1 7 3 6.77778 3 6.66667C3 6.11111 3.4 5.44444 4.3 5ZM13 9.44445C13 9.66667 12.9 9.88889 12.8 10.1111C12.6 10.3333 12.2 10.7778 11.7 11.1111C10.8 11.5556 9.5 11.8889 8 11.8889C6.5 11.8889 5.3 11.5556 4.3 11.1111C3.8 10.7778 3.4 10.3333 3.2 10C3.1 9.77778 3 9.55556 3 9.44445V8.66667C3.3 8.88889 3.6 9.11111 3.9 9.33333C4 9.33333 4.1 9.44445 4.2 9.44445C5.2 10 6.6 10.2222 8 10.2222C9.4 10.2222 10.8 9.88889 11.8 9.44445C11.9 9.44445 12 9.33333 12.1 9.33333C12.4 9.11111 12.7 9 13 8.66667V9.44445Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
